import React from "react";
import { Modal, Button } from "react-bootstrap";

import { URL_HELPER } from "../utils/constants";

import { archiveCompetition } from "../https_handler/apiHandler";

import "bootstrap/dist/css/bootstrap.min.css";
import "./SharedModal.css";

const ArchiveCompModal = ({ show, handleClose, user, activeCompetition, showErrorModal }) => {
    const [isLoading, setLoading] = React.useState(false);

    const hideModal = () => {
        if (!isLoading)
            handleClose();
    }

    const setUrlToBase = () => {
        window.location.href = URL_HELPER.URL_BASE_STRING;
    }

    const handleArchiveCompetition = async () => {
        if (!isLoading) {
            setLoading(true);
            const { error } = await archiveCompetition(user, activeCompetition.compInfo.compId);

            setLoading(false);

            if (error)
                showErrorModal(error);
            else
                setUrlToBase();
        }
    }

    return (
        <Modal
            size="lg"
            centered
            show={show}
            onHide={hideModal}
            className="custom-modal"
        >
            <Modal.Header closeButton>
                <h2 className="modal-heading">Delete Competition</h2>
            </Modal.Header>
            <Modal.Body>
                <div className="modal-form-group">
                    <p className="modal-text">
                        Are you sure you want to delete the competition "{activeCompetition ? activeCompetition.compInfo.title : ''}"?
                    </p>
                    <p className="modal-text" style={{ color: 'var(--error)', fontSize: '0.875rem' }}>
                        This action cannot be undone.
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button 
                    className="modal-btn secondary" 
                    onClick={hideModal}
                    disabled={isLoading}
                >
                    Cancel
                </button>
                <button 
                    className="modal-btn danger" 
                    onClick={handleArchiveCompetition}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <span className="modal-loading">
                            <span>Deleting...</span>
                        </span>
                    ) : (
                        'Delete Competition'
                    )}
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default ArchiveCompModal;